import React, { useEffect } from 'react'
import { graphql } from 'gatsby'
import Seo from '@components/Seo'
import { useStore } from '@Store/'
import { setHeaderColor, setShowHeaderBackground } from '@Store/'
import Hero from '@components/_SubService/Hero'
import PageFooter from '@components/_Service/PageFooter'
import { getNamedColor } from '@utils'
import { colors } from '@styles/vars/colors.style'
import Builder from '@components/_SubService/Builder'

const SubServicePage = ({ data }) => {
  const [, dispatch] = useStore()
  const {
    seo,
    slug,
    pageSeoTitle,
    parentService,
    backgroundColor: heroBackgroundColourName,
    textColor: heroTextColourName,
    title,
    bannerTitle,
    bannerImage,
    subServiceContent,
    pageFooter,
  } = data.contentfulSubService

  const caseStudies = data.allContentfulCaseStudy.nodes;

  const heroBackgroundColour = getNamedColor(heroBackgroundColourName)
  const heroTextColour = getNamedColor(heroTextColourName)

  useEffect(() => {
    setHeaderColor(dispatch, heroTextColour, heroBackgroundColour)
    setShowHeaderBackground(dispatch, true);
  }, [dispatch, heroTextColour, heroBackgroundColour])

  return (
    <div>
      <Seo data={seo} slug={`what-we-do/${parentService.slug}/${slug}`} />

      <Hero
        bgColor={heroBackgroundColour}
        tColor={heroTextColour}
        name={title}
        parentService={parentService}
        title={bannerTitle}
        image={bannerImage}
        pageSeoTitle={pageSeoTitle}
      />

      <Builder 
          data={subServiceContent}
          backgroundColor={heroBackgroundColour} 
          textColor={heroTextColour}
          slug={slug}
          caseStudies={caseStudies}
      >
      </Builder>

      {pageFooter && (
        <PageFooter content={pageFooter} customBackground={heroTextColour} customText={colors.charcoal} />
      )}
    </div>
  )
}

export default SubServicePage

export const pageQuery = graphql`query SubServicePage($slug: String!) {
  
  contentfulSubService(slug: {eq: $slug}) {
    title
    slug
    seo {
      ...SEO
    }
    pageSeoTitle
    backgroundColor
    textColor
    bannerImage {
      ...Image
    }
    bannerTitle {
      raw
    }
    parentService {
        slug
        title
    }
    subServiceContent {
      ... on ContentfulServiceCaseStudies {
        __typename
        title
        background
      }
      ... on ContentfulServiceGallery {
        __typename
        title
        background
        itemsStyle
        titleStyle
        gridColumns
        items {
          ...Image
        }
      }
      ... on ContentfulServicePartners {
        __typename
        title
        subTitle
        background
        itemsStyle
        titleStyle
        useDarkLogos
        isClickable
        partnerItems {
          slug
          featuredImage {
            ...Image
          }
          lightImage {
            ...Image
          }
          darkImage {
            ...Image
          }
        }
      }
      ... on ContentfulTestimonySlides {
        __typename
        title
        quotes {
          label
          quote {
            quote
          }
          quoteContent {
            raw
          }
          image {
            ...Image
          }
          authorName
          authorDescription {
            authorDescription
          }
          link {
            ... on Node {
              ...Link
            }
          }
        }
      }
      ... on ContentfulFeaturedInformation {
        __typename
        title
        color
        layout
        featuredTitle {
          raw
        }
        featuredContent {
          raw
        }
        featuredImage {
          ...Image
        }
      }
      ... on ContentfulVimeoVideo {
        __typename
        videoId
        coverImage {
          ...Image
        }
      }
    }
    pageFooter {
      ...PageFooter
    }
  }
  allContentfulCaseStudy(
    filter: {subService: {elemMatch: {slug: {eq: $slug}}}}
  ){
    nodes {
      slug
      title
      metadata {
        tags {
          name
        }
      }
      mainImage {
        gatsbyImageData(height: 420, width: 420)
        description
      }
      secondaryImage {
        gatsbyImageData(height: 420, width: 420)
        description
      }
      heroText {
        raw
      }
    }
  }
}`
